import React, { useState } from 'react';
import { VoxelDialog } from '@wikifactory/voxel-ui';
import { observer } from 'mobx-react';
import { Spinner, Divisor, Button } from 'components';
import { useAppManager } from 'core/hooks';
import type CreateShipmentQuoteAppManager from 'apps/shipmentQuote/appManager';

import { columns } from 'apps/productQuote/ProductQuoteTables';
import { ProductQuoteApp } from 'apps/productQuote/app';
import { TableSection } from 'apps/productQuote/ProductQuoteTables/TableSection';
// import { ProductQuoteHeader } from 'apps/productQuote/ProductQuoteHeader';
import { ProductQuoteAppManager } from 'apps/productQuote/productQuoteAppManager';
import { LargePanelSectionWrapper } from 'libs/rendering/gltf/components/largePanel/styles';
import { FormWrapper, FieldsWrapper } from 'libs/forms/styles';
import { confToFields } from 'libs/forms';

import { RowActionButtons } from './RowActionButtons';
import { ShipmentQuoteButton } from './ShipmentQuoteButton';

// function getCheckBoxColumn(shipmentQuoteAppManager: CreateShipmentQuoteAppManager) {
//   return {
//     Header: '',
//     accessor: '',
//     // for some reason this 'any' type annotation is necessary
//     Cell: function checkbox(productQuote: ProductQuoteApp) {
//       const handleChange = () => {
//         // change the URL to add the ProductQuote ids
//         shipmentQuoteAppManager.AddOrRemoveProductQuoteId(productQuote);
//       };
//       const pqids = routerStore.params.get('pqids') || [];
//       return (
//         <Checkbox
//           onChange={handleChange}
//           checked={pqids.includes(productQuote.dgraphId)}
//           value={productQuote.dgraphId}
//           id={productQuote.dgraphId}
//         />
//       );
//     },
//   };
// }

interface ProductQuoteProps {
  shipmentQuoteAppManager: CreateShipmentQuoteAppManager;
  productQuoteApp: ProductQuoteApp;
  onModalClose: () => void;
  // t: (key: string) => string;
  rfqApp: any; // TODO
}

const dialogStyled = {
  '& .MuiDialogContent-root': {
    overflowY: 'inherit',
    paddingTop: '0px',
  },
  '& .MuiPaper-root': {
    overflowY: 'visible',
  },
};

export const IntermediatorRFQProductQuotes = observer(
  function IntermediatorRFQProductQuotes({
    // shipmentQuoteAppManager,
    // productQuoteApp,
    rfqApp,
  }: ProductQuoteProps) {
    const productQuoteAppManager = useAppManager(ProductQuoteAppManager, null, {
      fromRFQ: rfqApp,
    });
    const finalColumns = columns.slice(3);
    const productQuotes = productQuoteAppManager.productQuotes || [];
    const { loading } = productQuoteAppManager.productQuotesQ;
    const customerSlug = rfqApp.customerSpace.path;

    // const warningMessage =
    //   shipmentQuoteAppManager.numSelectedPqs > 1 ? (
    //     <Box sx={{ width: '100%' }}>
    //       <Banner variant='warning' size='small'>
    //         Warning: you have added more than one quote for the same RFQ.
    //         That&apos;s unusual but valid if e.g. you are quoting both a mould
    //         and a production run.
    //       </Banner>
    //     </Box>
    //   ) : null;

    const handleCloseDialog = () => {
      productQuoteAppManager.SetExtendQuoteDialogVisible(false);
    };

    return (
      <LargePanelSectionWrapper>
        {/* <ProductQuoteHeader productQuoteApp={productQuoteApp} /> */}
        {(productQuotes.length !== 0 && (
          <TableSection
            loading={false}
            columns={finalColumns}
            nodes={productQuotes}
            title='Part Quotes (internal)' // t('Part Quotes (internal)')
            RowActionButtons={props => {
              return (
                <RowActionButtons
                  {...props}
                  onExtendQuote={() => {
                    productQuoteAppManager.SetExtendQuoteDialogVisible(true);
                    productQuoteAppManager.SetExtendQuoteId(props.node.id);
                  }}
                  showExtendIcon={!props.node.isInstantQuote}
                  appManager={productQuoteAppManager}
                />
              );
            }}
            dataTestId='intermediatorRFq-product-quotes'
            emptyTablePlaceholder={null}
            isDivisorVisible={false}
          />
        )) ||
          (loading && <Spinner margin='1rem 0' />)}
        <ShipmentQuoteButton
          customerSlug={customerSlug}
          rfqId={rfqApp.dgraphId}
        />
        <Divisor mt={8} />
        <VoxelDialog
          style={{
            // Promise level more than subheader component zIndex.
            zIndex: 1000000,
          }}
          sx={dialogStyled}
          open={productQuoteAppManager.extendQuoteDialogVisible}
          onBackdropClick={handleCloseDialog}
          onClose={handleCloseDialog}
          actions={
            <>
              <Button
                data-testid='extend-quote-submit-button'
                margin='0 auto'
                type='submit'
                size='small'
                outline
                loading={productQuoteAppManager.extendQuoteFormStore.posting}
                text='Submit'
                onClick={e => {
                  productQuoteAppManager.ExtendProductQuote();
                  e.preventDefault();
                }}
              />
            </>
          }
        >
          <FormWrapper ml={0} responsive>
            <FieldsWrapper responsive>
              {confToFields({
                formStore: productQuoteAppManager.extendQuoteFormStore,
                refs: {},
                responsive: true,
              })}
            </FieldsWrapper>
          </FormWrapper>
        </VoxelDialog>
      </LargePanelSectionWrapper>
    );
  },
);
